import { render, staticRenderFns } from "./faqsMain.vue?vue&type=template&id=3949b216&scoped=true&"
import script from "./faqsMain.vue?vue&type=script&lang=js&"
export * from "./faqsMain.vue?vue&type=script&lang=js&"
import style0 from "./faqsMain.vue?vue&type=style&index=0&id=3949b216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949b216",
  null
  
)

export default component.exports